var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiltersIcon = function SvgFiltersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#18A318"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 5.833a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-2.916a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833M10 6.667h6.667V5H10zm3.333 7.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m1.25-2.917a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833m-11.25 2.083V15H10v-1.667z"
  })));
};
export default SvgFiltersIcon;